import type { Props } from './Svg'
import { Svg } from './Svg'

export function TrashIcon(props: Props) {
  return (
    <Svg width="16" height="20" stroke="none" fill="currentColor" {...props}>
      <path d="M13.7 6.2h1.5v12.3c0 .8-.7 1.5-1.5 1.5H2.9c-.8 0-1.5-.7-1.5-1.5V6.2h1.5v12.3h10.8V6.2Zm-8.5 0v10h1.6v-10H5.2Zm4.6 0v10h1.6v-10H9.8ZM16 3v1.5H.6V3.1H4L5 .9A2 2 0 0 1 6.6 0H10c.6 0 1.2.3 1.4.9L12.6 3H16ZM5.7 3h5.2l-.8-1.6H6.5L5.7 3Z" />
    </Svg>
  )
}
